import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/ui/spinner';
import { useAuthStore } from '@/stores/auth-store';

import { LandingAboutTeamSection } from './landing-about-team-section';
import { LandingCtaSection } from './landing-cta-section';
import { LandingMarketingShell, LandingReveal } from './landing-shared';
import './landing.css';

export const AboutPage = () => {
  const { t } = useTranslation('landing');
  const status = useAuthStore((state) => state.status);
  const restore = useAuthStore((state) => state.restore);
  const signedIn = status === 'authenticated';
  const paragraphs = t('about.paragraphs', { returnObjects: true }) as string[];

  useEffect(() => {
    if (status === 'unknown') void restore();
  }, [status, restore]);

  if (status === 'unknown') {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-brand">
        <Spinner className="size-6 text-brand" />
      </div>
    );
  }

  return (
    <LandingMarketingShell signedIn={signedIn}>
      <main className="text-on-brand">
        <section className="py-12 sm:py-16">
          <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8">
            <LandingReveal className="text-center">
              <p className="text-caption font-semibold uppercase tracking-[0.2em] text-on-brand/75">
                {t('about.eyebrow')}
              </p>
              <h1 className="landing-display mt-3 text-balance text-[2rem] font-semibold tracking-tight sm:text-[2.25rem]">
                {t('footer.tagline')}
              </h1>
            </LandingReveal>

            <LandingReveal className="mt-8 space-y-4 text-pretty text-body leading-relaxed text-on-brand/90 sm:text-card-title">
              {paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </LandingReveal>
          </div>
        </section>

        <LandingAboutTeamSection />

        <LandingCtaSection signedIn={signedIn} />
      </main>
    </LandingMarketingShell>
  );
};
